module.exports = __webpack_public_path__ + "img/photo_in-use@1x.2b10dd38.jpg";